import React from 'react';
export function Footer() {
  return <footer className="bg-plum text-white" data-id="element-52" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-4xl px-5 py-12 text-center" style={{
      paddingTop: "25px",
      paddingBottom: "14px"
    }} data-id="element-53" data-mp="3gf96f0gd6eb2">
        <p className="font-display text-xl font-black text-white" data-id="element-54" data-mp="32onigxc1ze6b">
          SIGMA SMART<span className="align-super text-xs" data-id="element-55" data-mp="36p6df098t0cq">™</span> — 100+ AI PROMPTS FOR 911 DISPATCHERS<span className="align-super text-xs" data-id="element-56" data-mp="36n3bpiyq9is6">™</span>
        </p>

        <p className="mt-4 font-display text-base font-semibold italic text-grape-soft" data-id="element-57" data-mp="3ufjww2drhqvp">
          “Finish Your Narratives Before Shift Change.”
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-white/75" data-id="element-58" data-mp="3levg4zwzhcf4">
          <a href="mailto:soporte.sigmasmart@gmail.com" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-59" data-mp="3qcnjcq32wkym">
            📧 soporte.sigmasmart＠gmail.com
          </a>
          <a href="#" className="inline-flex items-center gap-2 transition-colors duration-150 ease-out hover:text-white" data-id="element-60" data-mp="2ez1l8ff8r90y">
            📲 ＠sigmasmart.en
          </a>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-white/55" data-id="element-61" data-mp="3gb8x35faxiwn">
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-62" data-mp="3v7zwheoz6um9">
            Terms & Conditions
          </a>
          <span data-id="element-63" data-mp="3q7buxz34evds">·</span>
          <a href="#" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-64" data-mp="3qazo2x4nlfrz">
            Privacy Policy
          </a>
          <span data-id="element-65" data-mp="34patc8mu2kd">·</span>
          <a href="mailto:soporte.sigmasmart@gmail.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-66" data-mp="335tdib8plh0">
            Support
          </a>
        </div>

        <p className="mt-6 text-[11px] leading-relaxed text-white/45" data-id="element-67" data-mp="ctgw51j6tomb">
          This toolkit helps you organize your own facts after the call. Use de-identified information only, follow your agency’s AI policy and never use AI during a live call. The AI never decides priorities, codes or units and never gives caller instructions. It does not replace your agency’s policies, protocols, training or legal advice.
        </p>
        <p className="mt-4 text-xs leading-relaxed text-white/45" data-id="element-68" data-mp="yuza1tlzh7k9">
          © 2026 SIGMA SMART™ — All rights reserved.
        </p>
      </div>
    </footer>;
}